import {
  WorkerRequirementDomain,
  WorkerRequirementMappingLevel,
} from "@clipboard-health/contract-worker-app-bff";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { type WorkerRequirement } from "../../Documents/api/types";
import { SHIFT_DISCOVERY_NC_ORIENTATION_PATH } from "../../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

interface NCOrientationRequirementMapping {
  id: string;
  type: "requirement-mappings";
  attributes: {
    requirementId: string;
    level: WorkerRequirementMappingLevel;
    qualifications: string[];
    workplaceTypes: string[];
    requiredBy: string[];
    requiredForBooking: boolean;
    domain: WorkerRequirementDomain;
    isOrientationRequirement?: boolean;
  };
}

export interface NCOrientationWorkerRequirement extends WorkerRequirement {
  requirementMappings?: NCOrientationRequirementMapping[];
}

export function hasNCOrientationRequirement(blockingRequirements: WorkerRequirement[]): boolean {
  return (blockingRequirements as NCOrientationWorkerRequirement[]).some(
    (requirement) =>
      requirement.requirementMappings?.some(
        (m) => m.attributes.isOrientationRequirement === true
      ) === true
  );
}

export function NCOrientationRequiredCard() {
  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="neutral"
      title="North Carolina Orientation"
      description="You must complete this orientation before booking shifts in North Carolina."
      illustrationType="unlock"
      footer={
        <Button
          fullWidth
          variant="contained"
          size="medium"
          onClick={() => {
            history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_NC_ORIENTATION_PATH}`);
          }}
        >
          Start Orientation
        </Button>
      }
    />
  );
}
